import { Controller } from '@hotwired/stimulus'
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static targets = ["CreateOrderFormContainer", "CreateOrderFormStep1", "CreateOrderForm", "CreateOrderFormButton"]

  async onStatusChange(e) {
    const formData = new FormData(e.currentTarget.form)

    const request = new FetchRequest('patch', e.currentTarget.dataset.url, { body: formData, responseKind: 'json' })
    const response = await request.perform()

    if (response.ok) {
      //  do something with response
    }
  }

  onCreateOrderClick(e) {
    e.preventDefault()

    this.CreateOrderFormContainerTarget.classList.remove("hidden")
  }

  onCancelCreateOrderClick() {
    this.CreateOrderFormContainerTarget.classList.add("hidden")
  }

  async onCreateOrderFormSubmit(e) {
    e.preventDefault()

    let orderFormData = new FormData()
    orderFormData.append("order[lead_id]", this.truckloadOrderIdValue)
    orderFormData.append("order[name]", this.customerNameValue)
    orderFormData.append("order[email]", this.customerEmailValue)
    orderFormData.append("order[email_confirmation]", this.customerEmailValue)
    orderFormData.append("order[phone_number]", this.customerPhoneValue)
    orderFormData.append("order[billing_state]", this.customerStateValue)
    orderFormData.append("order[shipping_state]", this.customerStateValue)
    orderFormData.append("order[business_type]", this.customerBusinessTypeValue.includes("Farm") ? "farm" : "business")
    orderFormData.append("order[loading_option]", this.customerUnloadingOptionsValue.includes("Dock") ? "loading_dock" : this.customerUnloadingOptionsValue.includes("Forklift") ? "forklift" : "liftgate")
    orderFormData.append("order[shipping]", this.selectedRateShippingAmount)

    let request = new FetchRequest('post', "/admin/orders", { body: orderFormData, responseKind: 'json' })
    let response = await request.perform()

    if (response.ok) {
      let order = await response.json

      let orderItemData = new FormData()
      orderItemData.append("order_item[order_id]", order.id)
      orderItemData.append("order_item[quantity]", this.OrderQuantityInputTarget.value)
      orderItemData.append("order_item[listing_id]", this.OrderListingIdInputTarget.value)
      orderItemData.append("order_item[via_cms]", true)

      request = new FetchRequest('post', `/admin/order_items`, { body: orderItemData, responseKind: 'json' })
      response = await request.perform()

      if (response.ok) {
        let orderItem = await response.json
        navigator.clipboard.writeText(orderItem.order.payment_intent_url)
        this.onCancelCreateOrderClick()
        window.location = `/admin/orders/${orderItem.order.id}`
      }
    } else {
      alert(await response.text)
    }
  }

  onEditNoteClick(e) {
    const url = e.currentTarget.dataset.editFormUrl
    const request = new FetchRequest('get', url, { responseKind: 'turbo-stream' })
    request.perform()
  }

  onDeleteNoteClick(e) {
    e.preventDefault()
    e.stopPropagation()

    if (window.confirm(e.target.dataset.confirmText)) {
      const request = new FetchRequest(e.target.dataset.method, e.target.dataset.url, { responseKind: 'turbo-stream' })
      request.perform()
    }
  }

}